import React from "react";

export default function TopUsers({ users }) {
  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 min-h-[240px] flex flex-col">
      <h3 className="font-bold text-[12px] text-gray-900 mb-3">Top Contributing Users</h3>
      <div className="divide-y divide-gray-100">
        {users.map((u, idx) => (
          <div
            key={idx}
            className="py-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
          >
            <div className="flex items-center gap-2 min-w-0">
              <img src={u.avatar} alt={u.name} className="w-7 h-7 rounded-full object-cover flex-shrink-0" />
              <div className="min-w-0">
                <p className="text-[11px] font-semibold text-gray-900 truncate">{u.name}</p>
                {u.email && <p className="text-[10px] text-gray-500 truncate">{u.email}</p>}
              </div>
            </div>
            <div className="flex items-center gap-6">
              <div className="text-[10px] text-gray-600 text-left sm:text-right">
                <div>Questions</div>
                <div className="font-bold text-gray-900">{u.questions ?? u.answered ?? 0}</div>
              </div>
              <div className="text-[10px] text-gray-600 text-left sm:text-right">
                <div>Answers</div>
                <div className="font-bold text-gray-900">{u.answers ?? u.points ?? 0}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

